import css from 'styled-jsx/css';

const styles = css.global`#energia-solar-passo-a-passo {
  overflow: hidden;
  padding-bottom: 40px;
}

#energia-solar-passo-a-passo .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#energia-solar-passo-a-passo .passo-a-passo-titulo {
  margin: 0;
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 42px; 
}

#energia-solar-passo-a-passo .passo-a-passo-carrossel .slide {
  display: flex;
  gap: 24px;
  align-items: center;
  width: 240px;
  height: 260px;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #444;
  margin-right: 24px;
  flex: 0 0 240px;
}

#energia-solar-passo-a-passo .passo-a-passo-carrossel .slide:first-child {
  width: 222px;
  flex: 0 0 222px;
}

#energia-solar-passo-a-passo .passo-a-passo-carrossel .slide .slide-numero {
  color: #739E41;
  text-align: center;
  font-family: "SantanderText";
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 60px;
}

#energia-solar-passo-a-passo .passo-a-passo-carrossel .slide .slide-textos {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
  height: 228px;
}

#energia-solar-passo-a-passo .passo-a-passo-carrossel .slide .slide-titulo {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

#energia-solar-passo-a-passo .passo-a-passo-carrossel .slide .slide-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#energia-solar-passo-a-passo .home-pagination {
  margin-top: 24px;
  max-width: 304px;
}

#energia-solar-passo-a-passo .home-pagination .embla__prev.enable-mobile-arrows, 
#energia-solar-passo-a-passo .home-pagination .embla__next.enable-mobile-arrows {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

#energia-solar-passo-a-passo .pagination-container .bullet {
  background-color: #222;
}

#energia-solar-passo-a-passo .pagination-container .bullet.active, 
#energia-solar-passo-a-passo .pagination-container .bullet[selected] {
  background-color: #739E41;
}

@media (min-width: 992px) {
  #energia-solar-passo-a-passo {
    padding-top: 48px;
    padding-bottom: 64px;
  }

  #energia-solar-passo-a-passo .ctn-home-24 {
    gap: 40px;
  }
  
  #energia-solar-passo-a-passo .passo-a-passo-titulo {
    font-size: 40px;
    line-height: 60px; 
  }

  #energia-solar-passo-a-passo .passo-a-passo-carrossel .custom-carousel {
    /* margin-top: 16px; */
    overflow: hidden;
  }
  
  #energia-solar-passo-a-passo .passo-a-passo-carrossel .slide,
  #energia-solar-passo-a-passo .passo-a-passo-carrossel .slide:first-child {
    width: 420px;
    height: 152px;
    flex: 0 0 420px;
  }

  #energia-solar-passo-a-passo .passo-a-passo-carrossel .slide .slide-textos {
    height: auto;
  }


  #energia-solar-passo-a-passo .home-pagination {
    margin-top: 64px;
  }
}`;

export default styles;